export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">剧集反馈、合作洽谈、内容投稿</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-500">content@wowo.tv</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-team-line text-2xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">biz@wowo.tv</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-question-line text-2xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">问题反馈</h3>
                <p className="text-xs text-foreground-500">help@wowo.tv</p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200">
              <p className="text-sm text-foreground-600 text-center leading-relaxed">
                如果你有好的剧集推荐、原创剧评想要分享，或者发现任何播放问题，
                <br className="hidden sm:block" />
                欢迎随时通过以上方式联系我们。我们珍视每一位追剧同好的声音。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}